import { XStack, YStack } from '@/components/ui/layout/layout';

import { UsageCard, UsageCardEmpty } from './UsageCard';

import type { TeamUsageResponse, UsageFeature } from '../../team.types';

const FEATURE_LABELS: Record<UsageFeature, string> = {
  chat: 'Chat',
  integrations: 'Integrations',
  meetings: 'Meetings',
  routines: 'Routines',
};

export function FeatureAdoptionCard({
  adoption,
}: {
  adoption: TeamUsageResponse['feature_adoption'];
}) {
  const hasAdoption = adoption.some((entry) => entry.pct_of_active_members > 0);
  return (
    <UsageCard
      title="Feature adoption"
      subtitle="Share of active members who used each feature"
    >
      {hasAdoption ? (
        <YStack className="flex-1 justify-center gap-6 py-2">
          {adoption.map((entry) => {
            const pct = Math.round(entry.pct_of_active_members);
            return (
              <XStack key={entry.feature} className="items-center gap-3">
                <span className="w-[5.5rem] shrink-0 text-sm text-foreground">
                  {FEATURE_LABELS[entry.feature]}
                </span>
                <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-surface-active">
                  <div
                    className="h-full rounded-full bg-accent"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="w-11 shrink-0 text-right text-sm font-semibold tabular-nums text-foreground">
                  {pct}%
                </span>
              </XStack>
            );
          })}
        </YStack>
      ) : (
        <UsageCardEmpty
          title="No feature activity"
          description="Adoption will appear once members start using Littlebird."
        />
      )}
    </UsageCard>
  );
}
